import { PayloadAction } from "@reduxjs/toolkit";
import type {
  IDrofusInterfaceChangeType,
  IDrofusInterfaceDiscipline,
} from "@multiconsult-group/multiplacer-core";
import { createAppSlice } from "../app/createAppSlice";

export interface IDrofusChangesState {
  dateFrom: string;
  dateTo: string;
  changeTypes: IDrofusInterfaceChangeType[];
  affectedDisciplines: IDrofusInterfaceDiscipline[];
}

export const DROFUS_CHANGES_DISCIPLINE_OPTIONS: Array<{
  value: IDrofusInterfaceDiscipline;
  label: string;
  color: string;
}> = [
  { value: "RIE", label: "RIE", color: "#f59f00" },
  { value: "RIKT", label: "RIKT", color: "#1971c2" },
  { value: "RIAut", label: "RIAut", color: "#9c36b5" },
  { value: "RIV", label: "RIV", color: "#0c8599" },
];

const formatDateInputValue = (date: Date): string => date.toISOString().slice(0, 10);

const getDefaultDrofusChangesState = (): IDrofusChangesState => {
  const dateTo = new Date();
  const dateFrom = new Date(dateTo);
  dateFrom.setDate(dateFrom.getDate() - 7);

  return {
    dateFrom: formatDateInputValue(dateFrom),
    dateTo: formatDateInputValue(dateTo),
    changeTypes: [],
    affectedDisciplines: [],
  };
};

export const drofusChangesSlice = createAppSlice({
  name: "drofusChanges",
  initialState: getDefaultDrofusChangesState(),
  reducers: () => ({
    setDrofusChangesDateFromInRedux: (state, action: PayloadAction<string>) => {
      state.dateFrom = action.payload;
    },
    setDrofusChangesDateToInRedux: (state, action: PayloadAction<string>) => {
      state.dateTo = action.payload;
    },
    toggleDrofusChangesChangeTypeInRedux: (
      state,
      action: PayloadAction<IDrofusInterfaceChangeType>
    ) => {
      state.changeTypes = state.changeTypes.includes(action.payload)
        ? state.changeTypes.filter((changeType) => changeType !== action.payload)
        : [...state.changeTypes, action.payload];
    },
    toggleDrofusChangesAffectedDisciplineInRedux: (
      state,
      action: PayloadAction<IDrofusInterfaceDiscipline>
    ) => {
      state.affectedDisciplines = state.affectedDisciplines.includes(action.payload)
        ? state.affectedDisciplines.filter((discipline) => discipline !== action.payload)
        : [...state.affectedDisciplines, action.payload];
    },
  }),
});

export const {
  setDrofusChangesDateFromInRedux,
  setDrofusChangesDateToInRedux,
  toggleDrofusChangesChangeTypeInRedux,
  toggleDrofusChangesAffectedDisciplineInRedux,
} = drofusChangesSlice.actions;
